import React from "react";
import "../css/TextFile.css";

function Skills() {
  return (
    <div className="textfile-container">
      <h4>Programming Languages</h4>
      <p>Python, Java</p>
      <p>HTML, CSS, JavaScript/TypeScript (React)</p>
      <br />

      <h4>Other Skills</h4>
      <p>Prometheus, Grafana, Splunk</p>
      <p>ElasticSearch, MongoDB</p>
      <p>Kubernetes, Docker, AWS</p>
      <p>Bitbucket, Confluence, Jira</p>
      <p>Figma</p>
    </div>
  );
}

export default Skills;
